module.exports = __webpack_public_path__ + "static/img/chenzhong.4f289f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/chenzhong.png
// module id = iv+S
// module chunks = 3